import { useMemo } from 'react';
import { isInIframe } from '../utils/iframe';

/**
 * React hook для определения, загружено ли приложение в iframe
 *
 * @returns {boolean} true если приложение в iframe, false если в обычном окне
 *
 * @example
 * function MyComponent() {
 *   const isIframe = useIframeDetection();
 *
 *   return (
 *     <div>
 *       {!isIframe && <Header />}
 *       <MainContent />
 *       {!isIframe && <Footer />}
 *     </div>
 *   );
 * }
 */
export const useIframeDetection = () => {
  // Используем useMemo чтобы детекция выполнилась только один раз
  const isIframe = useMemo(() => {
    const result = isInIframe();
    console.log('[useIframeDetection] App is running in iframe mode:', result);
    return result;
  }, []);

  return isIframe;
};
